/* Constants */
import pizzaDescription from '@/constants/htmlPizzaDescription'
import rollyDescription from '@/constants/htmlRollyDescription'
import setyDescription from '@/constants/htmlSetyDescription'

/**
 * Функция для получения дефолтных SEO описаний для категорий
 *   Это хардкод, нужный чтобы не проставлять описания для каждого города отдельно,
 *   пока не появилась фича на беке
 * @param categorySlug - slug категории
 * @param city - строка города
 * @param phone - номер телефона ресторана города
 */
export const getSeoDesc = (
  categorySlug: string | string[],
  city: string,
  phone: string,
): string => {
  if (!categorySlug) return ''

  switch (categorySlug) {
    case 'pizza':
      return pizzaDescription(city)
    case 'rolly':
      return rollyDescription(city, phone)
    case 'sety':
      return setyDescription(city, phone)
    default:
      return ''
  }
}
